@if (!isMobile) {
    <div class="bin-metrics-container">
        @if(!selectedBinInfo) {
            <div class='spinner-container'>
                <div class="spinner"></div>
            </div>
        }
        <div [ngClass]="{'hide-content': !selectedBinInfo}">
            <div class="bin-metrics-container-header" rtlDiv>
                @if ((user_role_id == 5 || user_role_id == 6) && bin_type_id != -1) {
                    @if(enableActiveQuickSamplingPlan) {
                      <div class="activate-quick-sampling-plan" [class.disabled]="activateClick" (click)="activateQuickSamplingPlan()">
                        {{'LIVE_INFO.ACTIVATE_QUICK_SAMPLING_PLAN' | translate }}
                      </div>
                    }@if(!enableActiveQuickSamplingPlan) {
                      <div class="activate-quick-sampling-plan" [class.disabled]="stopClick" (click)="stopQuickSamplingPlan()">
                        {{'LIVE_INFO.STOP_QUICK_SAMPLING_PLAN' | translate }}
                      </div>
                    }
                  }
            </div>
            <div class="bin-metrics-container-capacity">
                <circle-progress class="circle-progress"
                    [percent]="user_role_id == 5 || user_role_id == 6 ? capacityLevelUnfiltered : capacityLevel"
                    [maxPercent]="100"
                    [toFixed]="0"
                    [showTitle]="false"
                    [showUnits]="false"
                    [showSubtitle]="false"
                    [showInnerStroke]="true"
                    [animation]="false"
                    [outerStrokeGradient]="false"
                    [radius]="75"
                    [outerStrokeColor]="'#4F8F6F'"
                    [innerStrokeWidth]="20"
                    [outerStrokeWidth]="20"      
                    [innerStrokeColor]="'#E9E9E9'"
                    [space]="-20">
                </circle-progress>
                <div class="bin-metrics">
                    <div class="bin-metrics-text-value">
                        <span>{{user_role_id == 5 || user_role_id == 6 ? capacityLevelUnfiltered : capacityLevel}}</span>
                        @if (usageType == 1) {
                        <span>%</span>
                        }
                        @if (usageType == 2 && currentLang == 'iw') {
                        <span> ל</span>
                        }
                        @if (usageType == 2 && currentLang != 'iw') {
                        <span> L</span>
                        }
                    </div>
                    <div class="bin-metrics-text-title">
                        {{'LIVE_INFO.CAPACITY' | translate }}
                    </div>
                </div>
            </div>
            <div class="bin-metrics-container-footer">
                <div class="bin-metrics-container-kpis">
                    <div class="metrics-item-container">
                        <img src="assets/images/binInfoPage/next_excepted.svg" alt="" />
                        <div class="data-container">
                          <div class="text-number" rtlDiv>
                            {{(currentLang == 'iw' ? utilService.convertDateHebrew(selectedBinInfo?.Bin_live_Data.Transmission_data.expected_transmission_time) : utilService.convertDateEnglish(selectedBinInfo?.Bin_live_Data.Transmission_data.expected_transmission_time))}}
                        </div>
                          <div class="text-title" rtlDiv>{{ 'LIVE_INFO.NEXT_EXPECTED_TRANS' | translate }}</div>
                        </div>
                    </div>
                    <div class="middle-divider"></div>
                    <div class="metrics-item-container">
                        <img [src]="currentBatteryStatus" alt="batteryStatus" />
                        <div class="data-container">
                          <div class="text-number" rtlDiv>
                            @if(binBatteryLevel >= 0 && binBatteryLevel <= 25){
                                {{ 'BATTERY_STATUS.CRITICAL' | translate }}
                            }@else if(binBatteryLevel >= 26 && binBatteryLevel <= 50){
                                {{ 'BATTERY_STATUS.LOW' | translate }}
                            }@else if(binBatteryLevel >= 51 && binBatteryLevel <= 75){
                                {{ 'BATTERY_STATUS.NORMAL' | translate }}
                            }@else{
                                {{ 'BATTERY_STATUS.GOOD' | translate }}
                            }
                          </div>
                          <div class="text-title" rtlDiv>{{'TITLES.BATTERY_STATUS' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="horizontal-divider"></div>
                <div class="bin-metrics-live-data">
                    <div class="bin-metrics-live-data-item">
                        <div class='metrics-item-container fixed-width'>
                            <img src="assets/images/binInfoPage/temperature.svg" alt="" />
                            <div class="data-container">
                                <div class='text-number' [ngClass]="{'rtl-text': currentLang == 'iw'}">
                                    {{binTemprature}}
                                    <span class='circle-celcius'></span>
                                </div>
                                <div class='text-title' rtlDiv>{{'LIVE_INFO.TEMPERATURE' | translate }}</div>
                            </div>
                        </div>
                        <div class='progress-bar'>
                            <app-progress-bar-color [backgroundColor]="'rgba(204, 241, 221, 0.2)'" [barColor]="'#CCF1DD'" [progressWidth]="'100%'"
                            [progressHeight]="'14px'" [percentage]="binTemprature" [rangeLow]="binTemperatureLow" [rangeHigh]="binTemperatureHigh"></app-progress-bar-color>
                        </div>
                    </div>
                    <div class="bin-metrics-live-data-item">
                        <div class='metrics-item-container fixed-width'>
                            <img src="assets/images/binInfoPage/humidity.svg" alt="" />
                            <div class="data-container">
                                <div class='text-number' rtlDiv>{{binHumidity}}%</div>
                                <div class='text-title' rtlDiv>{{'LIVE_INFO.HUMIDITY' | translate }}</div>
                            </div>
                        </div>
                        <div class='progress-bar'>
                            <app-progress-bar-color [backgroundColor]="'rgba(200, 225, 255, 0.5)'" [barColor]="'#C8E1FF'" [progressWidth]="'100%'"
                            [progressHeight]="'14px'" [percentage]="binHumidity" [rangeLow]="binHumidityLow" [rangeHigh]="binHumidityHigh"></app-progress-bar-color>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (isMobile) {

}
